module.exports = __webpack_public_path__ + "static/media/vf-button-knit.432ee44b.svg";